<template>
  <div class="um-page anCore-fill">
    <div class="row um-filters">
      <div class="form-group col-sm-4">
        <div class="input-group">
          <span class="input-group-addon">部门</span>
          <select class="form-control" v-model="depFilter">
            <option value=""> </option>
            <option v-for="d in departmentOptions" :key="d" :value="d">{{ d }}</option>
          </select>
        </div>
      </div>
      <div class="form-group col-sm-4">
        <div class="input-group">
          <span class="input-group-addon">姓名</span>
          <input
            type="text"
            class="form-control"
            v-model="key"
            placeholder="输入关键字查询"
            @keyup="onKeyup"
          >
        </div>
      </div>
    </div>

    <div class="um-table-wrap" v-loading="loading">
      <table class="table table-bordered um-table">
        <thead>
          <tr>
            <th>#</th>
            <th style="min-width:80px;">登陆账号</th>
            <th style="min-width:80px;">姓名</th>
            <th style="min-width:100px;">部门及岗位</th>
            <th style="min-width:150px;">联系地址及方式</th>
            <th style="min-width:185px;">操作时间</th>
            <th style="min-width:80px;">角色权限</th>
            <th style="width:110px;">
              <button type="button" class="btn btn-sm btn-success" @click="openEdit()">
                <i class="fa fa-plus" /> 新增
              </button>
            </th>
          </tr>
        </thead>
        <tbody v-if="filteredList.length">
          <tr v-for="(row, idx) in filteredList" :key="row.id || row.dlh">
            <td>{{ idx + 1 }}</td>
            <td>{{ row.dlh }}</td>
            <td>
              <label class="control-label">{{ row.xm }}</label>
            </td>
            <td>
              <div>
                <label>{{ row.deptName || row.dept_label || '—' }}</label>
              </div>
              <div v-if="row.postName" class="text-muted">({{ row.postName }})</div>
            </td>
            <td>
              <div v-if="row.homeAddress">{{ row.homeAddress }}</div>
              <div v-if="row.sjh"><label>{{ row.sjh }}</label></div>
              <div v-if="row.yx">{{ row.yx }}</div>
            </td>
            <td>
              <div>
                <span class="text-muted">系统注册:</span>
                {{ formatTime(row.registerDate || row.cjsj) }}
              </div>
              <div>
                <span class="text-muted">最近登陆:</span>
                {{ formatTime(row.lastLoginDate || row.gxsj) }}
              </div>
            </td>
            <td>
              <div class="text-warning">
                <span v-for="(r, ri) in roleNames(row)" :key="ri">{{ r }};</span>
              </div>
            </td>
            <td>
              <button type="button" class="btn btn-sm btn-link" title="设置或更新" @click="openEdit(row)">
                <i class="fa fa-edit" />
              </button>
              <button
                v-if="String(row.zt) === '1' && row.dlh !== 'admin'"
                type="button"
                class="btn btn-sm btn-link"
                title="停用"
                @click="disableUser(row)"
              >
                <i class="fa fa-trash-o text-muted" />
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8">
              <div class="text-center text-muted" style="padding:50px 0;">没有数据信息...</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <el-dialog :title="editForm.id ? '用户信息' : '新增用户'" :visible.sync="showEdit" width="640px" @open="onDialogOpen">
      <el-form :model="editForm" label-width="96px" size="small">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="登陆账号" required>
              <el-input v-model="editForm.dlh" :disabled="!!editForm.id && editForm.dlh === 'admin'" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" required>
              <el-input v-model="editForm.xm" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item :label="editForm.id ? '新密码' : '密码'" :required="!editForm.id">
              <el-input
                v-model="editForm.mm"
                type="password"
                show-password
                :placeholder="editForm.id ? '留空则不修改' : '初始密码'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-switch v-model="editForm.ztOn" active-text="启用" inactive-text="停用" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="手机"><el-input v-model="editForm.sjh" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱"><el-input v-model="editForm.yx" /></el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">角色权限</el-divider>
        <div v-for="g in roleGroups" :key="g.key" class="role-group">
          <div class="role-group-title">{{ g.label }}</div>
          <el-checkbox-group v-model="pickedJsids">
            <el-checkbox v-for="r in g.roles" :key="r.id" :label="String(r.id)" class="role-check">
              {{ r.jsmc }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/utils/api'

function padTime(s) {
  if (!s) return ''
  const t = String(s).replace('T', ' ').slice(0, 16)
  return t
}

export default {
  name: 'UserManage',
  data() {
    return {
      list: [],
      ivanByLogin: {},
      loading: false,
      key: '',
      depFilter: '',
      showEdit: false,
      saving: false,
      roleGroups: [],
      pickedJsids: [],
      editForm: {
        id: '',
        dlh: '',
        xm: '',
        mm: '',
        sjh: '',
        yx: '',
        ztOn: true
      }
    }
  },
  computed: {
    departmentOptions() {
      const set = {}
      this.list.forEach((u) => {
        const d = u.deptName || u.dept_label
        if (d) set[d] = true
      })
      return Object.keys(set).sort()
    },
    filteredList() {
      let rows = this.list.filter((u) => String(u.zt) === '1')
      if (this.depFilter) {
        rows = rows.filter((u) => (u.deptName || u.dept_label) === this.depFilter)
      }
      const k = String(this.key || '').trim()
      if (k) {
        rows = rows.filter((u) => String(u.xm || '').indexOf(k) >= 0 || String(u.dlh || '').indexOf(k) >= 0)
      }
      return rows
    }
  },
  mounted() {
    this.loadRoleOptions()
    this.loadIvanSnapshot().then(() => this.load())
  },
  methods: {
    formatTime: padTime,
    roleNames(row) {
      if (row.ivanRoles && row.ivanRoles.length) return row.ivanRoles
      return String(row.jsmc_ls || '')
        .split(/[,，;；]/)
        .map((s) => s.trim())
        .filter(Boolean)
    },
    async loadIvanSnapshot() {
      try {
        const url = (process.env.BASE_URL || '/') + 'ivan-sync/users.json'
        const r = await fetch(url)
        if (!r.ok) return
        const arr = await r.json()
        const map = {}
        ;(arr || []).forEach((u) => {
          const login = String(u.LoginName || '').trim()
          if (!login) return
          const dep = ((u.DepartmentList || [])[0] || {}).Department || {}
          const post = ((u.DepartmentList || [])[0] || {}).Post || {}
          const roles = (u.RoleInfoList || []).map((x) => x.RoleName).filter(Boolean)
          map[login] = {
            deptName: dep.DepartmentName || '',
            postName: post.PostName || '',
            homeAddress: u.HomeAddress || u.WorkAddress || '',
            phone: u.Phone || '',
            email: u.Email || '',
            registerDate: u.RegisterDate || '',
            lastLoginDate: u.LastLoginDate || '',
            ivanRoles: roles
          }
        })
        this.ivanByLogin = map
      } catch (e) {
        this.ivanByLogin = {}
      }
    },
    mergeIvan(row) {
      const snap = this.ivanByLogin[row.dlh] || {}
      return {
        ...row,
        deptName: snap.deptName || row.dept_label || '',
        postName: snap.postName || '',
        homeAddress: snap.homeAddress || '',
        sjh: row.sjh || snap.phone || '',
        yx: row.yx || snap.email || '',
        registerDate: snap.registerDate || row.cjsj || '',
        lastLoginDate: snap.lastLoginDate || '',
        ivanRoles: snap.ivanRoles || []
      }
    },
    async loadRoleOptions() {
      try {
        const res = await api.get('yn_role_options')
        this.roleGroups = (res.data && res.data.groups) || []
      } catch (e) {
        this.$message.error('加载角色配置失败')
      }
    },
    onKeyup() {
      /* 即时过滤，computed 已处理 */
    },
    async load() {
      this.loading = true
      try {
        const res = await api.get('yn_yh_admin_list', { key: '' })
        const items = (res.data && res.data.items) || []
        this.list = items.map((u) => this.mergeIvan(u))
      } catch (e) {
        this.$message.error((e.response && e.response.data) || '加载失败，请确认管理员权限')
      }
      this.loading = false
    },
    openEdit(row) {
      if (row) {
        this.editForm = {
          id: row.id,
          dlh: row.dlh,
          xm: row.xm,
          mm: '',
          sjh: row.sjh || '',
          yx: row.yx || '',
          ztOn: String(row.zt) === '1'
        }
      } else {
        this.editForm = { id: '', dlh: '', xm: '', mm: '', sjh: '', yx: '', ztOn: true }
        this.pickedJsids = []
      }
      this.showEdit = true
    },
    async onDialogOpen() {
      if (!this.editForm.id) return
      try {
        const res = await api.get('yn_yh_js_get', { target_yhid: this.editForm.id })
        this.pickedJsids = (res.data && res.data.jsids) || []
      } catch (e) {
        this.pickedJsids = []
      }
    },
    async save() {
      const f = this.editForm
      if (!f.dlh || !f.xm) {
        this.$message.warning('请填写登陆账号和姓名')
        return
      }
      if (!f.id && !f.mm) {
        this.$message.warning('新建用户须设置密码')
        return
      }
      if (!this.pickedJsids.length) {
        this.$message.warning('请至少勾选一个角色')
        return
      }
      this.saving = true
      try {
        const saveRes = await api.post('yn_yh_save', {
          id: f.id || '',
          dlh: f.dlh,
          mm: f.mm || '',
          xm: f.xm,
          sjh: f.sjh,
          yx: f.yx,
          zt: f.ztOn ? '1' : '0'
        })
        let yhid = f.id
        const body = saveRes.data
        if (!yhid) {
          if (body && body.id) yhid = body.id
          else if (typeof body === 'object' && body.ok) yhid = body.id
        }
        if (!yhid) {
          await this.load()
          const found = this.list.find((u) => u.dlh === f.dlh)
          yhid = found && found.id
        }
        if (!yhid) {
          this.$message.error('保存用户失败')
          return
        }
        await api.post('yn_yh_js_save', {
          target_yhid: String(yhid),
          jsids: JSON.stringify(this.pickedJsids.map(String))
        })
        this.$message.success('已保存')
        this.showEdit = false
        this.load()
      } catch (e) {
        this.$message.error('保存失败')
      }
      this.saving = false
    },
    disableUser(row) {
      this.$confirm('确定停用用户「' + row.xm + '」？', '提示', { type: 'warning' })
        .then(async () => {
          await api.post('yn_yh_save', {
            id: row.id,
            dlh: row.dlh,
            xm: row.xm,
            sjh: row.sjh || '',
            yx: row.yx || '',
            zt: '0'
          })
          this.$message.success('已停用')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.um-page {
  height: 100%;
  background: #fff;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
}
.um-filters {
  margin: 0 0 8px;
}
.um-filters .form-group {
  margin-bottom: 8px;
}
.input-group-addon {
  background: #eee;
  border: 1px solid #ccc;
  padding: 6px 12px;
  font-size: 13px;
  min-width: 48px;
  text-align: center;
}
.um-filters .form-control {
  height: 34px;
  border-radius: 0 4px 4px 0;
}
.um-filters .input-group {
  display: flex;
  width: 100%;
}
.um-filters .input-group .form-control {
  flex: 1;
}
.um-table-wrap {
  flex: 1;
  overflow: auto;
  height: calc(100% - 60px);
}
.um-table {
  margin-bottom: 0;
  background: #fff;
}
.um-table > thead > tr > th {
  background: #f9f9f9;
  white-space: nowrap;
  vertical-align: middle;
}
.um-table > tbody > tr > td {
  vertical-align: middle;
  font-size: 13px;
}
.control-label {
  margin: 0;
  font-weight: 600;
}
.text-warning {
  color: #8a6d3b;
}
.role-group {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f8fafc;
  border-radius: 4px;
}
.role-group-title {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 13px;
}
.role-check {
  display: block;
  margin: 6px 0;
  margin-left: 0 !important;
}
</style>
